import React from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';
import {Link} from 'react-router-dom';
import PasswordCHangeModal from './PasswordChangeModal';



export default function SignIn(param) {

  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');


  // handler
  function handleUsername(e){  setUsername(trim(e.target.value)); }
  function handlePassword(e){  setPassword(trim(e.target.value)); }

  function trim(stringToTrim) {
    return stringToTrim.replace(/^\s+|\s+$/g,"");
  }

  // 이메일 validation
  function validateEmailAddress(email) {
      var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      return expression.test(String(email).toLowerCase());
  }

  //비밀번호 엔터 클릭시 로그인
  function appKeyPress(e) {
    if (e.key === 'Enter') {
      goSignIn();
    }
  }

  function trim(stringToTrim) {
      return stringToTrim.replace(/^\s+|\s+$/g,"");
  }

  // 로그인 하기
  async function goSignIn(){
    if(trim(username) === '' || trim(password) === '' ) { alert("모든 항목을 입력하세요."); return;} 
    if(!validateEmailAddress(trim(username))) { alert('사용자 이름은 이메일 형식입니다.'); return; }


    const url = axiosUrl.signin;
    await axios.post(url,{
          username: username,
          password: password
    } )
    .then( response => {
        if(response.data.passwordExpired === true) {
          sessionStorage.setItem('tempToken', response.data.token);
          alert("비밀번호가 만기되었습니다.");
          // 모달창  실행 
          document.getElementById('changepw').click();

        } else {
          sessionStorage.setItem('loginToken', response.data.token);
          window.location.href='/';
        }
    })
    .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] SignIn.goSignin - ' + e);
            alert(e.response.data.error.message);
    });
  }

    return(
        <div className="login-box">
          <div className="login-logo">
            <a href="/"><b>myHealth</b>CMS</a>
          </div>
       
        <div className="card">
          <div className="card-body login-card-body">
            <p className="login-box-msg">로그인</p>
      
              <div className="input-group mb-3">
                <input type="text" className="form-control" placeholder="사용자 이름" id="id"  name="id" onChange={handleUsername} />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input type="password" className="form-control" placeholder="비밀번호" id="password" name="password"  onChange={handlePassword}  onKeyPress={appKeyPress}/>
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <button type="submit" className="btn btn-primary btn-block btn-flat" onClick={goSignIn} >로그인</button>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-6">
                  <Link to="/sign/password/reset"><button type="submit" className="btn btn-warning btn-block btn-flat" >비밀번호 초기화</button></Link>
                </div>
                <div className="col-6">
                  <Link to="/signup"><button type="submit" className="btn btn-danger btn-block btn-flat" >회원가입</button></Link>
                </div>
                
              </div>
          </div>
        </div>
        {/* 클릭하기 사용을 위한 모듈 생성 */}
        <a data-toggle="modal" data-target="#passwordChangeModal" id="changepw" />
        <PasswordCHangeModal check={false}></PasswordCHangeModal>
      </div>
      
      
    );
}